var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',{class:_vm.b()},[_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Días")]),_vm._l((_vm.entries),function(entry){return _c('td',[_vm._v(_vm._s(entry.avg))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }